import { useEffect, useState } from "react";
import type { monaco } from "../lib/monaco.ts";
import { Markdown } from "./Markdown.tsx";

export function isMarkdownPath(path: string): boolean {
  return /\.(md|markdown|mdx)$/i.test(path);
}

/** Rendered view of a text model; follows unsaved edits live. Uses the same sanitized renderer as the chat. */
export function MarkdownPreview({ model }: { model: monaco.editor.ITextModel }) {
  const [text, setText] = useState(() => model.getValue());
  useEffect(() => {
    setText(model.getValue());
    const sub = model.onDidChangeContent(() => setText(model.getValue()));
    return () => sub.dispose();
  }, [model]);
  return (
    <div className="md-preview" data-testid="md-preview">
      <Markdown text={text} />
    </div>
  );
}
